import React from 'react'
import RoleTable from 'components/Tables/Role/RoleTabe'
// import ServiceTable from 'components/Tables/Service/ServiceTable'
import ItemServicesTable from 'components/Tables/ItemServices/ItemServicesTable'

const ListItemService = () => {
  return (
    <div><ItemServicesTable /></div>
  )
}

export default ListItemService